// src/components/announcements/AnnouncementCard.js
import React, { useState } from 'react';
import './AnnouncementCard.css';

function AnnouncementCard({ 
  announcement, 
  userData, 
  onMarkAsRead, 
  onDelete, 
  isAdmin
}) {
  const [expanded, setExpanded] = useState(false);

  const getPriorityIcon = (priority) => {
    switch(priority) {
      case 'urgent': return '🔴';
      case 'important': return '🟡';
      case 'normal': return '🟢';
      case 'info': return '🔵';
      default: return '🟢';
    }
  };

  const getCategoryIcon = (category) => {
    switch(category) {
      case 'maintenance': return '🔧';
      case 'event': return '🎉';
      case 'emergency': return '🚨';
      case 'financial': return '💰';
      case 'rules': return '📋';
      default: return '📌';
    }
  };

  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'urgent': return '#dc3545';
      case 'important': return '#ffc107';
      case 'normal': return '#28a745';
      case 'info': return '#17a2b8';
      default: return '#6c757d';
    }
  };

  const handleClick = () => {
    if (!announcement.isRead) {
      onMarkAsRead(announcement.id);
    }
    setExpanded(!expanded);
  };

  return (
    <div 
      className={`announcement-card-container ${!announcement.isRead ? 'unread' : ''}`}
      style={{ borderLeft: `4px solid ${getPriorityColor(announcement.priority)}` }}
      onClick={handleClick}
    >
      <div className="announcement-card-header">
        <div className="announcement-left">
          <div className="announcement-icons-row">
            {announcement.is_pinned && <span className="icon">📌</span>}
            <span className="icon">{getPriorityIcon(announcement.priority)}</span>
            <span className="icon">{getCategoryIcon(announcement.category)}</span>
            <h3 className="announcement-title">
              {announcement.title}
            </h3>
            {!announcement.isRead && (
              <span className="new-badge">NEW</span>
            )}
          </div>
          
          <div className="announcement-meta">
            <span>By {announcement.author?.name || 'Admin'}</span>
            <span className="separator">•</span>
            <span>{new Date(announcement.created_at).toLocaleDateString()}</span>
            {announcement.expiry_date && (
              <>
                <span className="separator">•</span>
                <span className="expiry">
                  Expires: {new Date(announcement.expiry_date).toLocaleDateString()}
                </span>
              </>
            )}
          </div>
        </div>
        
        {isAdmin && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(announcement.id);
            }}
            className="delete-btn"
          >
            Delete
          </button>
        )}
      </div>

      <div className={`announcement-content ${expanded ? 'expanded' : ''}`}>
        <p>{announcement.content || announcement.message}</p>
      </div>

      {announcement.content && announcement.content.length > 150 && (
        <button 
          className="read-more-btn"
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(!expanded);
          }}
        >
          {expanded ? 'Show Less ↑' : 'Read More ↓'}
        </button>
      )}
    </div>
  );
}

export default AnnouncementCard;